import * as Yup from "yup";
import i18next from "i18next";

const getKeyFromPath = (path: string) => path.replace(/\[\d+\][.]/, "-").replace(".", "-");
const getKey = (props: any) => i18next.t(props.label || getKeyFromPath(props.path));

const useRequiredMessage = (props: any = {}) => {
	return `${i18next.t(getKey(props))} ${i18next.t("is-required-field")}`;
};

const useMaxMessage = (props: any = {}) => {
	const { max } = props;
	return i18next.t("max-field", { property: getKey(props), max });
};

const useSchema = Yup.object().shape({
	firstName: Yup.string().required(useRequiredMessage).max(60, useMaxMessage).label("first-name"),
	lastName: Yup.string().required(useRequiredMessage).max(60, useMaxMessage).label("last-name"),
	preferredLanguage: Yup.string().required(useRequiredMessage),
});

export default useSchema;
